const pad2 = (value) => String(value).padStart(2, '0');

const formatLocalDate = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
};

const toIsoDate = (value) => {
  if (!value) return '';
  if (value instanceof Date) return formatLocalDate(value);
  const str = String(value);
  if (str.includes('T')) return str.split('T')[0];
  const parsed = new Date(str);
  if (Number.isNaN(parsed.getTime())) return str;
  return formatLocalDate(parsed);
};

export const formatDateOnly = (value, fallback = '-') => {
  const result = toIsoDate(value);
  return result || fallback;
};

export const formatDateRange = (start, end, fallback = 'TBD') => {
  const startDate = toIsoDate(start);
  const endDate = toIsoDate(end);
  if (!startDate && !endDate) return fallback;
  if (!startDate) return endDate || fallback;
  if (!endDate) return startDate;
  return `${startDate} to ${endDate}`;
};
